import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TSalesProcessingStore } from './types';

// ====================================================:

// const getGpsrState = (state: TStoreState): TGpsrStore => state.gpsr;
// export const getGpsr = createSelector([getGpsrState], (gpsr: TGpsrStore) => gpsr);

// ====================================================:

// export const getRegParserLoad = createSelector(
// 	[getGpsr],
// 	(gpsr: TGpsrStore): boolean => gpsr.regParserLoading,
// );

export const getSalesProcessingState = (state: TStoreState): TSalesProcessingStore =>
	state.salesProcessing;

export const getSalesProcessing = createSelector(
	[getSalesProcessingState],
	(state: TSalesProcessingStore) => state,
);

// ====================================================:

export const getSalesProcessingLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.uploadedFilesLoading,
);

// ====================================================:

export const getSalesProcessingUploadedFiles = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.uploadedFiles,
);

// ====================================================:

export const getSalesProcessingProcessingTypes = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processingTypes,
);

// ====================================================:

export const getSalesProcessingProcessingTypesLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processingTypesLoading,
);

// ====================================================:

export const getSalesProcessingProcessFile = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processFile,
);

// ====================================================:
export const getSalesProcessingProcessFileError = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processFileError,
);

// ====================================================:

export const getSalesProcessingProcessFileSuccess = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processFileSuccess,
);

// ====================================================:

export const getSalesProcessingProcessFileLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.processFileLoading,
);

// ====================================================:

export const getSalesProcessingDownloadFile = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.downloadFile,
);

// ====================================================:

export const getSalesProcessingDownloadFileLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.downloadFileLoading,
);

// ====================================================:

export const getSalesProcessingFileStatuses = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.fileStatuses,
);

// ====================================================:

export const getSalesProcessingFileStatusesLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.fileStatusesLoading,
);

// ====================================================:

export const getSalesProcessingEmInvoicingFeeTypes = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.emInvoicingFeeTypes,
);

// ====================================================:

export const getSalesProcessingEmInvoicingFeeTypesLoading = createSelector(
	[getSalesProcessing],
	(state: TSalesProcessingStore) => state.emInvoicingFeeTypesLoading,
);
